import React from "react";
import { Cpu } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Model {
  name: string;
  size?: number;
  modified_at?: string;
  digest?: string;
}

interface ModelSelectorProps {
  models: Model[];
  selectedModel: string;
  onModelChange: (modelName: string) => void;
  disabled?: boolean;
}

export const ModelSelector: React.FC<ModelSelectorProps> = ({
  models,
  selectedModel,
  onModelChange,
  disabled = false,
}) => {
  return (
    <Select
      value={selectedModel}
      onValueChange={onModelChange}
      disabled={disabled}
    >
      <SelectTrigger className='w-full'>
        <div className='flex items-center space-x-2'>
          <Cpu className='h-4 w-4 text-muted-foreground' />
          <SelectValue placeholder='No models available' />
        </div>
      </SelectTrigger>
      <SelectContent>
        {models.length === 0 ? (
          <div className='px-3 py-2 text-sm text-muted-foreground'>
            No models found. Please install some models with Ollama.
          </div>
        ) : (
          models.map((model) => (
            <SelectItem key={model.name} value={model.name}>
              <div className='font-medium'>{model.name}</div>
              {model.size && (
                <div className='text-xs text-muted-foreground'>
                  {(model.size / 1024 / 1024 / 1024).toFixed(1)} GB
                </div>
              )}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
};
